import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const IconWrapper = styled.div`
  display: inline-block;
  font-size: 18px;
  color: ${props => props.color};
  &:hover {
    ${props =>
    props.hoverColor.length > 0
      ? `color: ${props.hoverColor};cursor: pointer;`
      : ""};
  }
  ${props =>
    css`
      ${props.costomStyles};
    `};
`;

const propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  costomStyles: PropTypes.string
};
const defaultProps = {
  color: "inherit",
  hoverColor: "",
  costomStyles: ""
};
export const Icon = ({ children, color, hoverColor, costomStyles }) => {
  return (
    <IconWrapper
      color={color}
      hoverColor={hoverColor}
      costomStyles={costomStyles}
    >
      {children}
    </IconWrapper>
  );
};

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Icons/Icon.js